var _defs, _circle, _path, _ellipse, _ellipse2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmiley66Percent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3d98c;}.cls-2{fill:#b3d96b;}.cls-3{fill:#515151;}.cls-4{fill:none;stroke:#515151;stroke-miterlimit:10;stroke-width:15px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200,
    cy: 200,
    r: 192.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200,12.5a187.55,187.55,0,0,1,73,360.27A187.55,187.55,0,0,1,127,27.23,186.38,186.38,0,0,1,200,12.5m0-10C90.92,2.5,2.5,90.92,2.5,200S90.92,397.5,200,397.5,397.5,309.08,397.5,200,309.08,2.5,200,2.5Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 114.16,
    cy: 163.21,
    rx: 33.58,
    ry: 37.03,
    transform: "translate(-38.59 35.4) rotate(-15.11)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 271,
    cy: 163.21,
    rx: 37.03,
    ry: 33.58,
    transform: "translate(32.67 371.24) rotate(-72.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120,250s75,40.81,151.09,0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley66Percent);
export default __webpack_public_path__ + "static/media/smiley-66-percent.081f2b80475414507026c10826bd0047.svg";
export { ForwardRef as ReactComponent };